'use client';
// Taken from (for Sentry error support): https://github.com/vercel/next.js/blob/d2caaeab6491f1be80b3779b83e2902fc73223f9/examples/with-sentry/pages/_app.js
import * as Sentry from '@sentry/nextjs';
import { useSession } from 'next-auth/react';
import { usePostHog } from 'posthog-js/react';
import { useEffect } from 'react';

export function LoggedInEffects() {
  const { data: session } = useSession();
  const user = session?.user;
  const posthog = usePostHog();

  // Track user login changes
  useEffect(() => {
    if (user?.id) {
      posthog?.identify(user.id, {
        stripe_customer_id: user?.stripe?.customerId,
      });
    }
  }, [user, posthog]);

  // Sentry
  useEffect(() => {
    if (user?.id) {
      Sentry.setUser({ id: user.id });
    } else {
      Sentry.setUser({ id: '' });
    }
  }, [user]);

  return null;
}
